module.exports = __webpack_public_path__ + "img/yt-xjoe_usdc.b6ff2fff.png";